import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { notes } from "./notesData";
import { Nav, Error, Ul, Div, Title, H2 } from "./elements";

export const Note = props => {
  const { slug } = useParams();
  let page = "";

  if (slug in notes) {
    page = notes[slug];
  }

  useEffect(() => {
    if (page !== "") {
      document.title = `${page.title} | Duane Hilton`;
    }
    window.scrollTo(0, 0);
  }, [page]);

  let content = <Error />;
  if (page !== "") {
    content = (
      <Div>
        <Nav />
        <Title>{page.title}</Title>
        <div>{page.body}</div>
      </Div>
    );
  }

  return content;
};

export const Notes = props => {
  useEffect(() => {
    document.title = "Notes | Duane Hilton";
    window.scrollTo(0, 0);
  }, []);
  let notesList = Object.keys(notes)
    .sort()
    .map(k => (
      <li key={k}>
        <Link to={"/notes/" + k}>{notes[k].title}</Link>
      </li>
    ));
  return (
    <Div>
      <Nav />
      <H2>Notes, ideas, and tips</H2>
      <Ul>{notesList}</Ul>
    </Div>
  );
};
